export default __webpack_public_path__ + "static/media/bg1.93d19a24.jpg";